import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EverydaySpendMfaEffects } from './store/effects/everyday-spend-mfa.effect';
import { EverydaySpendEffects } from './store/effects/everyday-spend.effect';
import { everydaySpendReducer } from './store/reducers/everyday-spend.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('everydaySpend', everydaySpendReducer),
    EffectsModule.forFeature([EverydaySpendEffects, EverydaySpendMfaEffects]),
  ],
})
export class EverydaySpendModule {}
